/*** IMPORTS FROM imports-loader ***/
var define = false;

import Flickity from 'flickity';
require('flickity-as-nav-for');

export function storiesSlider() {
  var sliderNav = document.querySelector('.stories__sliderNav');
  var flkty = new Flickity(sliderNav, {
    // options
    cellAlign: 'center',
    contain: true,
    wrapAround: true,
    prevNextButtons: true,
    pageDots: false,
    asNavFor: '.stories__slider',
    draggable: false,
    // adaptiveHeight: true,
    on: {
      ready: function () {
        setTimeout(() => {
          flkty.resize();
        }, 1000);
      }
    }
  });

  var slider = document.querySelector('.stories__slider');
  var flkty = new Flickity(slider, {
    // options
    cellAlign: 'center',
    contain: true,
    wrapAround: true,
    prevNextButtons: true,
    pageDots: false,
    adaptiveHeight: true,
    on: {
      ready: function () {
        setTimeout(() => {
          flkty.resize();
        }, 1000);
      }
    }
  });

  var tapArea, startX ;
    tapArea = document.querySelectorAll('.stories__sliderNav');
    startX = 0;
    for (var item of tapArea) {
      item.ontouchstart = function(e) {
          startX = e.touches[0].clientX;
      };
      item.ontouchmove = function(e) {
          if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable ) {
              e.preventDefault();
          }
      };
  }
}
